const accordion = (() => {
  const defaultAccordion = () => {
    const accordionItem = document.getElementsByClassName('js-trigger-accordion');

    for (let i = 0; i < accordionItem.length; i += 1) {
      accordionItem[i].addEventListener('click', function (event) {
        event.currentTarget.classList.toggle('js-active');
        const accordionContent = this.nextElementSibling;
        event.currentTarget.querySelector('.c-accordion__icon svg').classList.toggle('js-active');
        accordionContent.classList.toggle('js-active');
      });
    }
  };

  const productShowTable = () => {
    document.addEventListener('DOMContentLoaded', function() {
      function productDesktopShow() {
        const ntElements = document.querySelectorAll('.nt');
        
        ntElements.forEach(function(ntElement) {
            ntElement.addEventListener('click', function() {
                const productTable = ntElement.nextElementSibling;
                if (productTable && productTable.classList.contains('product-table')) {
                    productTable.classList.add('active');
                }
            });
        });
    
        const productTables = document.querySelectorAll('.product-table');
    
        productTables.forEach(function(productTable) {
            productTable.addEventListener('mouseleave', function() {
                productTable.classList.remove('active');
            });
        });
      }
      
      // İlk yüklemede kontrol et
      if (window.innerWidth > 992) {
        productDesktopShow();
      }
      
      // Pencere boyutu değiştiğinde kontrol et
      window.addEventListener('resize', function() {
          if (window.innerWidth > 992) {
            productDesktopShow();
          }
      });
  });
  };

  const animNumberScroll = () => {
    document.addEventListener('scroll', function() {
      const numberBalloon = document.querySelector('.balloon.ballon1');
      const numberBalloon2 = document.querySelector('.balloon.ballon2');
      const numberContainer = document.querySelector('.number-container');
      const LeftItem1 = document.querySelector('.left-image.item1');
      const LeftItem2 = document.querySelector('.left-image.item2');
      const rightImage = document.querySelector('.right-image');
  
      const containerRect = numberContainer.getBoundingClientRect();
  
      // Check if the .number-container is in the viewport
      if (containerRect.top <= window.innerHeight && containerRect.bottom >= 0) {
          const scrollPercentage = (window.innerHeight - containerRect.top) / (window.innerHeight + containerRect.height);
  
          // Adjust the scroll range for the animations
          const offset = scrollPercentage * 100;
  
          // Transform the elements based on the scroll position
          numberBalloon.style.transform = `translateY(${offset}px)`;
          numberBalloon2.style.transform = `translateY(-${offset}px)`;
          LeftItem1.style.transform = `translateY(-${offset}px)`;
          LeftItem2.style.transform = `translateY(-${offset}px)`;
          rightImage.style.transform = `translateY(${offset}px)`;
      } else {
          // Reset transformations if the .number-container is not in the viewport
          numberBalloon.style.transform = 'translateY(0)';
          numberBalloon2.style.transform = 'translateY(0)';
          LeftItem1.style.transform = 'translateY(0)';
          LeftItem2.style.transform = 'translateY(0)';
          rightImage.style.transform = 'translateY(0)';
      }
  });

    document.addEventListener('DOMContentLoaded', function() {
      const counters = document.querySelectorAll('.counter-item');
      const speed = 1000; // Artış hızı, ne kadar düşükse o kadar hızlı artar
      let isScrolling = false;
  
      // Sayfa scroll edildiğinde çalışacak fonksiyon
      window.addEventListener('wheel', function() {
          isScrolling = true;
      });
  
      // Mobil cihazlar için touchstart ve touchmove olaylarını dinle
      window.addEventListener('touchstart', function() {
          isScrolling = true;
      });
  
      window.addEventListener('touchmove', function() {
          isScrolling = true;
      });
  
      // Belirli aralıklarla kontrol ederek sayfanın scroll edilip edilmediğini kontrol eden fonksiyon
      setInterval(function() {
          if (isScrolling) {
              counters.forEach(counter => {
                  const rect = counter.getBoundingClientRect();
                  if (rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)) {
                      // Eğer counter div'i görünürse, sayıyı arttırmak için fonksiyonu çağır
                      updateCount(counter);
                  }
              });
              isScrolling = false;
          }
      }, 250);
  
      function updateCount(counter) {
          const updateCount = () => {
              // Noktaları kaldırarak mevcut sayıyı sayıya çevir
              const target = +counter.getAttribute('data-target').replace(/\./g, '');
              const count = +counter.innerText.replace(/\./g, '');
  
              const increment = target / speed;
  
              if (count < target) {
                  counter.innerText = formatNumber(Math.ceil(count + increment));
                  setTimeout(updateCount, 1);
              } else {
                  counter.innerText = formatNumber(target);
              }
          };
  
          const formatNumber = (number) => {
              return new Intl.NumberFormat('tr-TR').format(number);
          };
  
          updateCount();
      }
    });
  };

  const init = () => {
    defaultAccordion();
    productShowTable();
    animNumberScroll();
  };

  return {
    init,
  };
})();

export default accordion;
